import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'cstmsr-sun-lense-info',
    imports: [],
    templateUrl: './sun-lense-info.component.html',
    styleUrl: './sun-lense-info.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class SunLenseInfoComponent {

	@Output() close: EventEmitter<boolean> = new EventEmitter();

	callClose() {
		this.close.emit(true);
	}

}
